<template>
  <section>
    <gs-header title="Thêm mới bưu cục"
      :breadcrumbs="[
        {title: 'Quản lý bưu cục', route: {name: 'post-offices'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localPostOffice" :rules="rules" ref="createPostOfficeForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitPostOffice('createPostOfficeForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Tên bưu cục" prop="name">
              <el-input v-model="localPostOffice.name" placeholder="Tên bưu cục"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Số điện thoại" prop="phone">
              <el-input v-model="localPostOffice.phone" placeholder="Số điện thoại"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mã bưu cục" prop="code">
              <el-input v-model="localPostOffice.code" placeholder="Mã bưu cục"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Thành phố" prop="city_id" class="is-required">
              <el-select class="display-block " v-model="localPostOffice.city_id" @change="getDistrict" filterable placeholder="Chọn thành phố">
                <el-option
                  v-for="city in cities"
                  :key="city.id"
                  :label="city.name"
                  :value="city.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Quận huyện" prop="district_id" class="is-required">
              <el-select class="display-block " v-model="localPostOffice.district_id" filterable placeholder="Chọn quận huyện">
                <el-option
                  v-for="district in districts"
                  :key="district.id"
                  :label="district.name"
                  :value="district.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Hãng vận chuyển" prop="carrier_id">
              <el-select class="display-block " v-model="localPostOffice.carrier_id" filterable placeholder="Chọn hãng vận chuyển">
                <el-option
                  v-for="carrier in carriers"
                  :key="carrier.id"
                  :label="carrier.name"
                  :value="carrier.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Địa chỉ">
              <el-input name="searchmap" v-model="localPostOffice.address" placeholder="Địa chỉ"></el-input>
            </el-form-item>
            <el-form-item>
              <div id="map">

              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Vĩ độ" prop="lat" class="is-required">
              <el-input v-model="localPostOffice.lat" placeholder="Vĩ độ"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Kinh độ " prop="lng" class="is-required">
              <el-input v-model="localPostOffice.lng" placeholder="Kinh độ "></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Thêm mới</button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import mixins from './mixins'
import GoogleMapsLoader from 'google-maps'
import { addPostOffices } from 'src/api/postOffices'
import { head } from 'lodash'
export default {

  name: 'NewPostOffice',
  mixins: [mixins],
  data () {
    return {

    }
  },
  methods: {
    validateBeforeSubmitPostOffice () {
      this.submitting = true
      this.$refs.createPostOfficeForm.validate(valid => {
        if (valid) {
          this.changedData = false
          addPostOffices(this.localPostOffice).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm bưu cục  thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'post-offices'}, 'postOffices')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Thêm bưu cục thất bại',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    },
    newPostOffice () {
      this.localPostOffice = {
        name: '',
        phone: '',
        code: '',
        city_id: '',
        district_id: '',
        carrier_id: '',
        address: '',
        lat: 0,
        lng: 0
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    }
  },
  mounted () {
    GoogleMapsLoader.KEY = process.env.GOOGLE_APP_KEY
    GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
    GoogleMapsLoader.load((google) => {
      let markers = []
      let myLatLng = {lat: 21.0227804, lng: 105.801944}

      let map = new google.maps.Map(document.getElementById('map'), {
        zoom: 15,
        center: myLatLng
      })
      let marker = new google.maps.Marker({
        position: myLatLng,
        map: map,
        title: 'Hello World!',
        draggable: false
      })
      markers.push(marker)

      let searchBox = document.getElementsByName('searchmap')[0]
      let autocomplete = new google.maps.places.Autocomplete(searchBox)
      autocomplete.setComponentRestrictions({'country': ['vn']})

      autocomplete.addListener('place_changed', () => {
        let places = autocomplete.getPlace()
        let bounds = new google.maps.LatLngBounds()
        bounds.extend(places.geometry.location)
        marker.setPosition(places.geometry.location)
        this.localPostOffice.address = places.formatted_address
        map.fitBounds(bounds)
        map.setZoom(15)
      })
      google.maps.event.addListener(marker, 'position_changed', () => {
        let lat = marker.getPosition().lat()
        let lng = marker.getPosition().lng()
        placeMarker({lat: lat, lng: lng})
        this.localPostOffice.lat = lat
        this.localPostOffice.lng = lng
      })
      function placeMarker (location) {
        let marker = new google.maps.Marker({
          position: location,
          map: map
        })
        markers.push(marker)
      }
      function removeMarkers () {
        for (let i = 0; i < markers.length; i++) {
          markers[i].setMap(null)
        }
      }
      let geocoder = new google.maps.Geocoder()
      google.maps.event.addListener(map, 'click', (event) => {
        if (markers.length) {
          removeMarkers()
        }
        placeMarker(event.latLng)
        geocoder.geocode({
          'latLng': event.latLng
        }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this.localPostOffice.address = results[0].formatted_address
              let lat = event.latLng.lat()
              let lng = event.latLng.lng()
              this.localPostOffice.lat = lat
              this.localPostOffice.lng = lng
            }
          }
        })
      })
    })
  }
}
</script>

<style lang="css" scoped>
#map {
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// NewPostOffice.vue?476b2c22